exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PointOfSales{color:red}.modal-header{background:#2196f3;text-align:center;color:#f0f8ff;width:100.1%;border-radius:5px 5px 0 0}.modal-header h3{line-height:1}.btn_standar{min-width:110px}.btn_standar,.btn_transitions{transition:.3s ease-out}.table_container{margin:20px auto}@media (min-width:992px){.modal-lg{width:700px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/point-of-sales/point-of-sales.scss
// module id = 1233
// module chunks = 0